import React from "react";
import { useBcomeVersionMap } from "../../../components/DbVersion";
import VersionSkeleton from "../../../components/VersionSkeleton";
import "./TraceabilityVersionValue.css";

/**
 * The project's traceability Version Set. While a traceability upload runs
 * (pendingBcomeVersionId), shows the version it moves from and the one it moves to when
 * they differ, marked as uploading. The project only gets the new one if the upload
 * succeeds; otherwise it keeps (and shows again) the previous one.
 */
const TraceabilityVersionValue = ({ record, pendingBcomeVersionId, emptyLabel = "-" }) => {
  const bcomeVersionMap = useBcomeVersionMap();
  const currentId = record?.bcomeVersionId;
  const isChanging = !!pendingBcomeVersionId && pendingBcomeVersionId !== currentId;
  const isLoadingVersion =
    (!!currentId && !bcomeVersionMap[currentId]) ||
    (!!pendingBcomeVersionId && !bcomeVersionMap[pendingBcomeVersionId]);

  if (isLoadingVersion) return <VersionSkeleton />;

  const currentLabel = bcomeVersionMap[currentId] || record?.version || emptyLabel;

  return (
    <>
      {isChanging ? (
        <span data-testid="traceability-version-change">
          <span className="traceability-version__from">{currentLabel}</span>
          {" → "}
          {bcomeVersionMap[pendingBcomeVersionId]}
        </span>
      ) : (
        currentLabel
      )}
      {pendingBcomeVersionId && (
        <span className="traceability-version__pending" data-testid="traceability-version-uploading">
          {" "}
          · uploading…
        </span>
      )}
    </>
  );
};

export default TraceabilityVersionValue;
